import { useQuery } from '@tanstack/react-query';
import apiClient from '../../../lib/apiClient';
import { enhanceVendor } from '../../../lib/vendorCoverage';

/**
 * Fetch the list of vendors with at least one verified coverage cell from
 * `GET /api/zero-trust/vendors?q=<search>`. Backend filters to verified-only
 * and ranks by name. Results are enhanced with client-side display metadata
 * (color, aliases) via `enhanceVendor`.
 *
 * @param {string} [query] — optional server-side name filter. When empty,
 *   returns the full list.
 */
export function useVendorList(query = '') {
  return useQuery({
    queryKey: ['zt-vendor-list', query || '__all__'],
    queryFn: async () => {
      const qs = query ? `?q=${encodeURIComponent(query)}` : '';
      const rows = await apiClient.get(`/api/zero-trust/vendors${qs}`);
      return Array.isArray(rows) ? rows.map(enhanceVendor).filter(Boolean) : [];
    },
    staleTime: 60_000,
  });
}
